import * as bootstrap from 'bootstrap'
import { initializeApp } from 'firebase/app'
import { getAuth, createUserWithEmailAndPassword, sendEmailVerification } from 'firebase/auth'
import { getDatabase, ref, set } from 'firebase/database'

const firebaseConfig = {
  apiKey: "AIzaSyCtSfIQyZua3V5lpmthL-Q49trkv9phV4g",
  authDomain: "webstructrual.firebaseapp.com",
  databaseURL: "https://webstructrual.firebaseio.com",
  projectId: "webstructrual",
  storageBucket: "webstructrual.appspot.com",
  messagingSenderId: "157062586915"
}

initializeApp(firebaseConfig)

    
//https://www.freecodecamp.org/news/reusable-html-components-how-to-reuse-a-header-and-footer-on-a-website/
export default class SignUpModalComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="modal fade" id="modal-sign-up-form" tabindex="-1" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <div class="text-center">
              <h3 class="">Create an account</h3>
              <div class="progress">
                <div class="progress-bar progress-bar-striped bg-default" role="progressbar" style="width: 50%"
                  aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">1.
                  Create account</div>
                <div class="progress-bar bg-default" role="progressbar" style="width: 50%" aria-valuenow="50"
                  aria-valuemin="0" aria-valuemax="100"><span class="text-light">2. Start subscription</span></div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th></th>
                    <th class="text-center">
                      Basic
                    </th>
                    <th class="text-center">
                      Pro
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><i class="fa fa-save fa-fw"></i> Save Projects</td>
                    <td class="text-center"><i class="fa fa-remove text-danger"></i></td>
                    <td class="text-center"><i class="fa fa-check text-success"></i></td>
                  </tr>
                  <tr>
                    <td><i class="fa fa-print fa-fw"></i> Print Results</td>
                    <td class="text-center"><i class="fa fa-remove text-danger"></i></td>
                    <td class="text-center"><i class="fa fa-check text-success"></i></td>
                  </tr>
                  <tr>
                    <td><i class="fa fa-calculator fa-fw"></i> Full Access to Beam Designer</td>
                    <td class="text-center"><i class="fa fa-remove text-danger"></i></td>
                    <td class="text-center"><i class="fa fa-check text-success"></i></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td class="text-center">Free</td>
                    <td class="text-center">$19 monthly</td>
                  </tr>
                </tbody>
              </table>
            </div>
    
            <div id="modal-sign-up-error" class="alert alert-danger d-none">asdf</div>
    
            <form>
              <div class="input-group" style="padding-bottom: 10px;">
                <span class="input-group-text"><i class="fa fa-user color-blue"></i></span>
                <input type="name" class="form-control" placeholder="Name" aria-label="Name" aria-describedby="Name"
                  autofocus autocomplete="name" id="sign-up-first-last">
              </div>
    
              <div class="input-group" style="padding-bottom: 10px;">
                <span class="input-group-text"><i class="fa fa-envelope color-blue"></i></span>
                <input type="email" class="form-control" placeholder="Email Address" aria-label="email"
                  aria-describedby="E-Mail" autocomplete="email" id="sign-up-email">
              </div>
    
              <div class="input-group" style="padding-bottom: 10px;">
                <span class="input-group-text"><i class="fa fa-lock color-blue"></i></span>
                <input type="password" class="form-control" placeholder="Password" name="password" value=""
                  aria-label="password" aria-describedby="Password" autocomplete="new-password" id="sign-up-password">
              </div>
    
              <div class="d-grid gap-2" style="padding-bottom: 10px;">
                <a href="#" class="btn btn-lg btn-success" id="modal-sign-up-button">
                  <span id="sign-up-wait-spinner" class="spinner-border  spinner-border-sm d-none"></span>
                  Get Started
                </a>
              </div>
    
              <div class="d-grid gap-2" style="padding-bottom: 10px;">
                <a href="#" class="btn btn-default btn-sm" data-bs-dismiss="modal" id="modal-sign-up-open-signin"
                  data-bs-toggle="modal" data-bs-target="#modal-login-form">
                  Already have an account? Login
                </a>
              </div>
    
              <div class="text-center">
                <small>
                  <a href="eula.html">By creating an account you agree to our Terms of Service</a>
                </small>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>`

    document.getElementById('modal-sign-up-button').addEventListener('click', signup)
  }
}

customElements.define('sign-up-modal-component', SignUpModalComponent)


function clearSignUpErrors() {
  document.getElementById('modal-sign-up-error').innerHTML = ''
  document.getElementById('modal-sign-up-error').classList.add('d-none')
}

function showSignupError(errorString) {
  document.getElementById('modal-sign-up-error').classList.remove('d-none')
  document.getElementById('modal-sign-up-error').innerHTML = errorString
  stopSignUpSpinner()
}

function startSignUpSpinner() {
  document.getElementById('sign-up-wait-spinner').classList.remove('d-none')
  document.getElementById('modal-sign-up-button').disabled = true
}

function stopSignUpSpinner() {
  document.getElementById('sign-up-wait-spinner').classList.add('d-none')
  document.getElementById('modal-sign-up-button').disabled = false
}

function signupTest() {
  // start spinner
  clearSignUpErrors()
  startSignUpSpinner()

  setTimeout(() => {
    document.getElementById('sign-up-wait-spinner').classList.add('d-none')
    bootstrap.Modal.getOrCreateInstance(document.getElementById('modal-sign-up-form')).hide()
    bootstrap.Modal.getOrCreateInstance(document.getElementById('modal-finish-upgrade')).show()
  }, 100)
}

function tempStubOnCreateuserSuccess() {
  console.log("customer created!")
}

function tempStubRedirectOnCreateUserSuccess(redirectPage) {
  window.location.replace(redirectPage);
}

function signup() {
  clearSignUpErrors()
  startSignUpSpinner()
   
  let firstLast = document.getElementById('sign-up-first-last').value.trim()
  let email = document.getElementById('sign-up-email').value.trim()
  let password = document.getElementById('sign-up-password').value.trim()

  if (!firstLast || !email || !password) {
    showSignupError('All fields required.')
    return
  }

  createUserWithEmailAndPassword(getAuth(), email, password).then((user) => {
    sendEmailVerification(getAuth().currentUser).catch((error) => {
      console.error(error)
      alert('Verification email could not be sent. Please try again later.')
    })
    
    set(ref(getDatabase(), 'users/' + getAuth().currentUser.uid), { username: firstLast }).then((docRef) => {
      bootstrap.Modal.getOrCreateInstance(document.getElementById('modal-sign-up-form')).hide()
    }).catch((error) => {
      console.error(error)
      alert(error)
    })
  }).catch((error) => {
    let str = error.message
    if(error.code === 'auth/email-already-in-use') {
      str = 'A user with that email address already exists.'
    }
    showSignupError(str)
  })
}
